<span *ngIf="badge" class="badge-container" [ngClass]="badge.style">
  <flo-raw-text *ngFor="let item of badge.items; index as i; trackBy: trackById" [rawText]="item"></flo-raw-text>
</span>
